import * as React from 'react';

type Props = {
  item: {
    name: string;
    description?: string;
    price: number;
  };
};

export class MenuItem extends React.PureComponent<Props> {
  public render() {
    const { item } = this.props;

    return (
      <div className="menu-item">
        <div className="menu-item__name">{item.name}</div>
        <div className="menu-item__price">€ {item.price.toFixed(2)}</div>
        <div className="menu-item__description">{item.description}</div>
      </div>
    );
  }
}
